import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Pluvas en la montar’, <br/>
        Kvazaŭ verŝas sin mar’, <br/>
        Kaj tempest’ furiozas terure. <br/>
        Kiel malsupreniĝos ni, ho amikar’? <br/>
        - Petveture, amik’, petveture!
      </p>

      <p class="poem-block mb-3">
        Foje sonĝis mi pri <br/>
        Notr-Dam’ de Parỉ’, <br/>
        Min allogas Eŭrop’ senmezure. <br/>
        Kiel trafu mi tien el fora patrỉ’? <br/>
        - Petveture, amik’, petveture!
      </p>

      <p class="poem-block mb-3">
        Oni diras, ke viv’ <br/>
        Estas kruta dekliv’, <br/>
        Sed ne glata ŝoseo velura. <br/>
        Spite ilin, mi trovis feliĉon en viv’ <br/>
        Petveture, amik’, petveture!
      </p>

      <p class="poem-block mb-3">
        Sed se venos la plag’ <br/>
        Kaj finiĝos la vag’, <br/>
        Ĉar nenio ekzistas sekura, <br/>
        Kiel min veturigos vi en lasta tag’? <br/>
        - Petveture, amik’, petveture!
      </p>

      <p class="poem-block mb-3">
        Logas la Paradiz’, <br/>
        Sed jen kia surpriz’ – <br/>
        La Infer’ por ni pretas torture! <br/>
        Ho Moŝtul’, kiel trafi ĉielen sen viz'? <br/>
        - Petveture, ho fil’, petveture!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Petveture'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: `
      Vadim Kondratjuk (Kievo), <br/>
      ${translator.esp}
    `
  }
}

export default item;